module.exports = __webpack_public_path__ + "img/child_home.d3c643e1.svg";